import { render, staticRenderFns } from "./PerformanceType.vue?vue&type=template&id=2b7b45be&"
import script from "./PerformanceType.vue?vue&type=script&lang=js&"
export * from "./PerformanceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports